module.exports = "/assets/data/8aaa32534ba53d8bd39509195690cc60-NG80.data.json";